import React, { Component } from "react";
import PropTypes from "prop-types";
import { Item, Grid, Header } from "semantic-ui-react";
import { Link } from "react-router-dom";
import { BackOfficeRoutes } from "@routes/urls";
import LiteratureTitle from "@modules/Literature/LiteratureTitle";
import DocumentAuthors from "@modules/Document/DocumentAuthors";
import { invenioConfig } from "@config";

export class SpecialCollectionListEntry extends Component {
  render() {
    const { result, record } = this.props;
    const data = result || record;

    if (!data || !data.metadata) {
      return <div>No metadata available</div>;
    }

    const {
      metadata: {
        pid,
        title = "Untitled",
        authors = [],
        academic_info: academicInfo,
        collection_type: collectionType,
        publication_year: publicationYear,
      },
    } = data;

    const department = academicInfo?.department;
    const program = academicInfo?.program;

    return (
      <Item>
        <Item.Content>
          <Item.Header
            as={Link}
            to={
              BackOfficeRoutes.specialCollectionDetailsFor
                ? BackOfficeRoutes.specialCollectionDetailsFor(pid)
                : `/backoffice/specialCollection/${pid}/details`
            }
            data-test={`navigate-${pid}`}
          >
            <div>
              <Header disabled as="h6" className="document-type">
                {collectionType?.replace(/_/g, " ") || "Collection"}
              </Header>
            </div>
            <LiteratureTitle title={title} truncateWidth="1200px" />
          </Item.Header>
          <Grid columns={3}>
            <Grid.Column computer={6} largeScreen={5}>
              <Item.Meta className="document-authors">
                <DocumentAuthors
                  authors={authors}
                  prefix="by "
                  limit={invenioConfig.LITERATURE?.authors?.maxDisplay || 3}
                />
                {(department || program) && (
                  <Item.Description>
                    {department}
                    {department && program && " | "}
                    {program}
                  </Item.Description>
                )}
              </Item.Meta>
              <Item.Description>
                <label>Completion Year:</label>{" "}
                {publicationYear || "No date available"}
              </Item.Description>
            </Grid.Column>
            {/* Placeholder for circulation status */}
            {/* <Grid.Column computer={4} largeScreen={3}>
              <Item.Description>
                <div>Available copies for loan</div>

                <div>Waiting list... -</div>
              </Item.Description>
            </Grid.Column> */}
          </Grid>
        </Item.Content>
        <div className="pid-field discrete">#{pid}</div>
      </Item>
    );
  }
}

SpecialCollectionListEntry.propTypes = {
  result: PropTypes.shape({
    metadata: PropTypes.shape({
      pid: PropTypes.string,
      title: PropTypes.string,
      authors: PropTypes.arrayOf(
        PropTypes.shape({
          full_name: PropTypes.string,
        })
      ),
      department: PropTypes.string,
      collection_type: PropTypes.string,
      publication_year: PropTypes.string,
    }),
  }),
  record: PropTypes.shape({
    metadata: PropTypes.shape({
      pid: PropTypes.string,
      title: PropTypes.string,
      authors: PropTypes.arrayOf(
        PropTypes.shape({
          full_name: PropTypes.string,
        })
      ),
      department: PropTypes.string,
      collection_type: PropTypes.string,
      publication_year: PropTypes.string,
    }),
  }),
};

SpecialCollectionListEntry.defaultProps = {
  result: null,
  record: null,
};
